/*
 * File: GetStudentCourseEnrollments.ts
 * Author: Austin Robinson
 * Date Created: 8/15/2023
 * Copyright (c) DrivingDoc 2023
 */

import { ErrorResponse, privateApi } from 'api';
import { createQuery } from 'react-query-kit'

export type GetSelfScheduledCoursePeriodsParams = {
    studentId: string;
    courseEnrollmentId: string;
    start: string;
    end: string;
};

export type SelfScheduledPeriod = {
    id: string;
    start: string;
    end: string;
    open_enrollment: string;
    close_enrollment: string;
    capacity: number;
    observation_capacity: number;
    waitlist_capacity: number;
    waitlist_observation_capacity: number;
    enrollment_performance_count: number;
    enrollment_observation_count: number;
    waitlist_performance_count: number;
    waitlist_observation_count: number;
    location: string;
    instructors: {
        id: string;
        name: string;
    }[];
};

async function getSelfScheduledPeriods(params: GetSelfScheduledCoursePeriodsParams) {
    if (!params.studentId || !params.courseEnrollmentId || !params.start || !params.end) {
        return null
    }
    // make api call
    const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/users/students/${params.studentId}/courseEnrollments/${params.courseEnrollmentId}/selfSchedulePeriods`, {
        params: {
            start: params.start,
            end: params.end
        }
    });

    return result.data as SelfScheduledPeriod[];
}

const useGetSelfScheduledPeriods = createQuery<SelfScheduledPeriod[] | null, GetSelfScheduledCoursePeriodsParams, ErrorResponse>({
    queryKey: ['self_scheduled_course_periods'],
    fetcher: (variables) => getSelfScheduledPeriods(variables),
});

export { useGetSelfScheduledPeriods };


